/* global axios */
import ApiClient from './ApiClient';

class MetaReportsAPI extends ApiClient {
  constructor() {
    super('reports/meta', { accountScoped: true, apiVersion: 'v2' });
  }

  getMessages({ inboxId, since, until }) {
    return axios.get(`${this.url}/messages`, {
      params: { inbox_id: inboxId, since, until },
    });
  }

  getTemplates({ inboxId, since, until }) {
    return axios.get(`${this.url}/templates`, {
      params: { inbox_id: inboxId, since, until },
    });
  }

  getTemplate({ inboxId, templateId, since, until }) {
    return axios.get(`${this.url}/template`, {
      params: { inbox_id: inboxId, template_id: templateId, since, until },
    });
  }
}

export default new MetaReportsAPI();
